import JSEncrypt from 'jsencrypt';
import { getPublicKey } from '@/api/publicKey';
/**
 * 最长加密长度
 * @type {number}
 */
const MAX_ENCRYPT_BLOCK = 117;
/**
 * @description RSA加密(支持长字符加密)
 * 前端只持有公钥（用于加密），私钥保留在服务端。
 * 原 vab demo 私钥已删除（前端不应持有私钥）。
 * @param data
 * @returns {Promise<{param: PromiseLike<ArrayBuffer>}|*>}
 */
export async function encryptedData(data) {
    let publicKey;
    const res = await getPublicKey();
    publicKey = res.data.publicKey;
    if (res.data.mockServer) {
        publicKey = '';
    }
    if (publicKey === '') {
        return data;
    }
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----${publicKey}-----END PUBLIC KEY-----`);
    let bufTmp = '';
    let hexTmp = '';
    let result = '';
    const buffer = Buffer.from(JSON.stringify(data));
    let offSet = 0;
    const inputLen = buffer.length;
    while (inputLen - offSet > 0) {
        if (inputLen - offSet > MAX_ENCRYPT_BLOCK) {
            bufTmp = buffer.slice(offSet, offSet + MAX_ENCRYPT_BLOCK);
        }
        else {
            bufTmp = buffer.slice(offSet, inputLen);
        }
        hexTmp = encrypt.encrypt(bufTmp.toString());
        result += atob(hexTmp);
        offSet += MAX_ENCRYPT_BLOCK;
    }
    return btoa(result);
}
/**
 * @description RSA解密 - 已禁用
 * 前端不应持有私钥，解密应由服务端完成。
 * 此函数保留仅为向后兼容，调用时抛错提醒迁移。
 */
export function decryptedData(_data) {
    throw new Error('decryptedData 已禁用：前端不应持有 RSA 私钥。请将解密逻辑迁移到服务端。');
}
